module.exports = __webpack_public_path__ + "static/media/photo-5.dba799ff.jpg";